var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLinkBank = function SvgLinkBank(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "257px",
    height: "107px",
    viewBox: "0 0 257 107",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4\u5907\u4EFD") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5B89\\u5168\\u8BBE\\u7F6E",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u65E0\\u94F6\\u884C\\u5361",
    transform: "translate(-635.000000, -348.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 1800,
    height: 1280
  }), /*#__PURE__*/React.createElement("g", {
    id: 3,
    transform: "translate(470.000000, 155.000000)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4\\u5907\\u4EFD",
    transform: "translate(635.000000, 345.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    fill: "#000000",
    cx: 48,
    cy: 61.0525,
    r: 48
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-2",
    transform: "translate(23.400000, 32.020000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62\\u5907\\u4EFD",
    fill: "#FFFFFF",
    x: 0,
    y: 44.0269511,
    width: 50,
    height: 5.20833333
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u77E9\\u5F62",
    fill: "#FFFFFF",
    points: "0.611772487 14.8809524 24.5866402 -2.83356525e-14 48.5615079 14.8809524 48.5615079 20.6679894 0.611772487 20.6679894"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.25,
    y1: 22.5477844,
    x2: 6.25,
    y2: 44.5477844,
    id: "\\u8DEF\\u5F84-9",
    stroke: "#FFFFFF",
    strokeWidth: 4.16666667
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.75,
    y1: 22.5477844,
    x2: 18.75,
    y2: 44.5477844,
    id: "\\u8DEF\\u5F84-9\\u5907\\u4EFD",
    stroke: "#FFFFFF",
    strokeWidth: 4.16666667
  }), /*#__PURE__*/React.createElement("line", {
    x1: 31.25,
    y1: 22.5477844,
    x2: 31.25,
    y2: 44.5477844,
    id: "\\u8DEF\\u5F84-9\\u5907\\u4EFD-2",
    stroke: "#FFFFFF",
    strokeWidth: 4.16666667
  }), /*#__PURE__*/React.createElement("line", {
    x1: 43.75,
    y1: 22.5477844,
    x2: 43.75,
    y2: 44.5477844,
    id: "\\u8DEF\\u5F84-9\\u5907\\u4EFD-3",
    stroke: "#FFFFFF",
    strokeWidth: 4.16666667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#FFFFFF",
    x: 3.125,
    y: 41.9436177,
    width: 6.25,
    height: 2.08333333
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-2",
    fill: "#FFFFFF",
    x: 15.625,
    y: 41.9436177,
    width: 6.25,
    height: 2.08333333
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-3",
    fill: "#FFFFFF",
    x: 28.125,
    y: 41.9436177,
    width: 6.25,
    height: 2.08333333
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-4",
    fill: "#FFFFFF",
    x: 40.625,
    y: 41.9436177,
    width: 6.25,
    height: 2.08333333
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M77.4868688,5.11336164 L77.5,5.12132034 C79.6511958,6.42514187 82.3488042,6.42514187 84.5,5.12132034 L84.5131312,5.11336164 C84.9854374,4.82710082 85.6003776,4.97792044 85.8866384,5.45022669 C86.0797236,5.76880099 86.0797236,6.1682945 85.8866384,6.4868688 L85.8786797,6.5 C84.5748581,8.65119577 84.5748581,11.3488042 85.8786797,13.5 L85.8866384,13.5131312 C86.1728992,13.9854374 86.0220796,14.6003776 85.5497733,14.8866384 C85.231199,15.0797236 84.8317055,15.0797236 84.5131312,14.8866384 L84.5,14.8786797 C82.3488042,13.5748581 79.6511958,13.5748581 77.5,14.8786797 L77.4868688,14.8866384 C77.0145626,15.1728992 76.3996224,15.0220796 76.1133616,14.5497733 C75.9202764,14.231199 75.9202764,13.8317055 76.1133616,13.5131312 L76.1213203,13.5 C77.4251419,11.3488042 77.4251419,8.65119577 76.1213203,6.5 L76.1133616,6.4868688 C75.8271008,6.01456255 75.9779204,5.39962245 76.4502267,5.11336164 C76.768801,4.92027645 77.1682945,4.92027645 77.4868688,5.11336164 Z",
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-6",
    fill: "#FFE100",
    transform: "translate(81.000000, 10.000000) rotate(-315.000000) translate(-81.000000, -10.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.17825,25.5885766 L22.13375,26.7737885 C24.1312889,27.9844799 26.6362111,27.9844799 28.63375,26.7737885 L30.58925,25.5885766 C30.7645937,25.4823022 30.9928902,25.538294 31.0991645,25.7136377 C31.1708474,25.8319084 31.1708474,25.9802204 31.0991645,26.0984911 L29.9139525,28.0539911 C28.7032611,30.05153 28.7032611,32.5564521 29.9139525,34.5539911 L31.0991645,36.509491 C31.2054388,36.6848347 31.149447,36.9131312 30.9741033,37.0194056 C30.8558326,37.0910884 30.7075207,37.0910884 30.58925,37.0194056 L28.63375,35.8341936 C26.6362111,34.6235022 24.1312889,34.6235022 22.13375,35.8341936 L20.17825,37.0194056 C20.0029063,37.1256799 19.7746098,37.0696881 19.6683355,36.8943444 C19.5966526,36.7760737 19.5966526,36.6277617 19.6683355,36.509491 L20.8535475,34.5539911 C22.0642389,32.5564521 22.0642389,30.05153 20.8535475,28.0539911 L19.6683355,26.0984911 C19.5620612,25.9231474 19.618053,25.6948509 19.7933967,25.5885766 C19.9116674,25.5168937 20.0599793,25.5168937 20.17825,25.5885766 Z",
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-7",
    fill: "#FFE100",
    transform: "translate(25.383750, 31.303991) rotate(-315.000000) translate(-25.383750, -31.303991) "
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62\\u5907\\u4EFD",
    fill: "#000000",
    cx: 208.8,
    cy: 61.0525,
    r: 48
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186,56 L233,56 L233,74.3 C233,75.7911688 231.791169,77 230.3,77 L188.7,77 C187.208831,77 186,75.7911688 186,74.3 L186,56 L186,56 Z",
    id: "\\u77E9\\u5F62",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#000000",
    x: 217.05,
    y: 64.9525,
    width: 9.45,
    height: 6.075,
    rx: 0.675
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.7,43 L230.3,43 C231.791169,43 233,44.2088312 233,45.7 L233,52 L233,52 L186,52 L186,45.7 C186,44.2088312 187.208831,43 188.7,43 Z",
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-4",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.976818,30.5657596 L236.05,31.8222975 C238.047539,33.0329889 240.552461,33.0329889 242.55,31.8222975 L244.623182,30.5657596 C244.782585,30.4691465 244.990127,30.5200481 245.08674,30.6794515 C245.151907,30.7869703 245.151907,30.9217994 245.08674,31.0293182 L243.830203,33.1025 C242.619511,35.1000389 242.619511,37.6049611 243.830203,39.6025 L245.08674,41.6756818 C245.183353,41.8350851 245.132452,42.0426274 244.973048,42.1392404 C244.86553,42.2044067 244.730701,42.2044067 244.623182,42.1392404 L242.55,40.8827025 C240.552461,39.6720111 238.047539,39.6720111 236.05,40.8827025 L233.976818,42.1392404 C233.817415,42.2358535 233.609873,42.1849519 233.51326,42.0255485 C233.448093,41.9180297 233.448093,41.7832006 233.51326,41.6756818 L234.769797,39.6025 C235.980489,37.6049611 235.980489,35.1000389 234.769797,33.1025 L233.51326,31.0293182 C233.416647,30.8699149 233.467548,30.6623726 233.626952,30.5657596 C233.73447,30.5005933 233.869299,30.5005933 233.976818,30.5657596 Z",
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-5",
    fill: "#FFE100",
    transform: "translate(239.300000, 36.352500) rotate(-315.000000) translate(-239.300000, -36.352500) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.525019,52.9301688 L123.78645,57.1915998 C124.208217,57.6133661 124.208217,58.2971842 123.78645,58.7189505 C123.58287,58.9225307 123.306432,59.036399 123.018528,59.0352668 L114.462016,59.0016167 C113.865553,58.999271 113.383926,58.5138407 113.386271,57.9173778 C113.387404,57.6294626 113.503452,57.3539179 113.708642,57.1519435 L118.003723,52.9241625 C118.426435,52.5080741 119.105606,52.5107556 119.525019,52.9301688 Z",
    id: "\\u77E9\\u5F62",
    fill: "#000000",
    fillRule: "nonzero",
    transform: "translate(118.740214, 55.609039) scale(-1, -1) rotate(-45.000000) translate(-118.740214, -55.609039) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120.071026,
    y1: 55.8805088,
    x2: 142.751026,
    y2: 55.8982273,
    id: "\\u8DEF\\u5F84-2\\u590D\\u5236",
    stroke: "#000000",
    strokeWidth: 4.32,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.091224,63.352114 L144.352655,67.613545 C144.774421,68.0353112 144.774421,68.7191294 144.352655,69.1408957 C144.149075,69.3444758 143.872636,69.4583442 143.584732,69.457212 L135.02822,69.4235619 C134.431757,69.4212162 133.95013,68.9357859 133.952476,68.339323 C133.953608,68.0514078 134.069657,67.7758631 134.274846,67.5738886 L138.569927,63.3461077 C138.992639,62.9300193 139.671811,62.9327008 140.091224,63.352114 Z",
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-8",
    fill: "#000000",
    fillRule: "nonzero",
    transform: "translate(139.306419, 66.030984) scale(-1, -1) rotate(-225.000000) translate(-139.306419, -66.030984) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 115.295607,
    y1: 65.7417958,
    x2: 137.975607,
    y2: 65.7595143,
    id: "\\u8DEF\\u5F84-2\\u590D\\u5236\\u5907\\u4EFD",
    stroke: "#000000",
    strokeWidth: 4.32,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillRule: "nonzero",
    transform: "translate(126.635607, 65.750655) scale(-1, 1) rotate(-180.000000) translate(-126.635607, -65.750655) "
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLinkBank);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/link-bank.b3f2ef63.svg";